import React from "react";
import image from "../../assets/images/Vector (4).png";

const CustomOrderInstructionCard = ({ title }) => {
  return (
    <div className="flex items-center justify-center my-4 bg-white ">
      <div className="p-4 text-center">
        <img src={image} alt="image" className="w-12 h-12 mx-auto" />
        <p className="mt-2 text-sm text-black lg:text-lg">{title}</p>
      </div>
    </div>
  );
};

export default CustomOrderInstructionCard;
